const {
  API_URL,
  CDN_HOST,
  COMMIT_HASH,
  CSP_ALLOW_UNSAFE_SCRIPTS,
  CSP_NONCE_PLACEHOLDER,
  CSP_PROJECT_NAME,
  CSP_REPORT_BASE_URL,
  CSP_REPORT_SAMPLING_INTERVAL,
  ENABLE_API_PROXY,
  PROXY_URL,
  SERVE_NEXT_STATIC_ASSETS,
} = process.env;

const routes = require('./app/common/next/routes');

const isProduction = () => process.env.NODE_ENV === 'production';

module.exports = {
  apiUrl: API_URL,
  commitHash: COMMIT_HASH,
  errorTracking: {
    sentryDsn:
      'https://739967869f5e4187ac584ed82319ea6d@app.getsentry.com/55522',
  },
  realUserMonitoring: {
    clientToken: 'pub34f37b767b492f56ae0f6a96fd8366dd',
    applicationId: '0ba71a62-0fd6-4978-9068-2334ebbab924',
  },
  isProduction: isProduction(),
  next: {
    dir: './src',
  },
  routes,
  serviceName: 'web-ssr',
  zapier: {
    API_URL,
    CDN_HOST,
    CSP_ALLOW_UNSAFE_SCRIPTS,
    CSP_NONCE_PLACEHOLDER,
    CSP_PROJECT_NAME,
    CSP_REPORT_BASE_URL,
    CSP_REPORT_SAMPLING_INTERVAL,
    ENABLE_API_PROXY,
    PROXY_URL,
    SERVE_NEXT_STATIC_ASSETS,
  },
  // web-ssr historically has implemented its own version of the Zapier
  // Universal Nav, and footer, which is customized by several pages within
  // this service.
  universalLayout: false,
};
